<template>
  <default-modal
    v-model="modalOpened"
    name="tfa-modal"
    :title="$t('backup_codes')"
    :actionLabel="$t('regenerate_codes')"
    :successHandler="handleRegenerate"
  >
    <template slot="content">
      <p v-html="$t('backup_codes_body')"></p>

      <backup-codes-area :backup-codes="backupCodes" class="q-mt-lg q-mb-sm"/>

      <q-inner-loading :visible="loading"></q-inner-loading>
    </template>
  </default-modal>
</template>

<script>
  import AuthorizationDialog from 'components/Common/AuthorizationDialog.vue'
  import BackupCodesArea from './Components/BackupCodesArea.vue'
  import { BackupCodesClient } from 'src/api/BackupCodes'
  import DefaultModal from 'components/Modal/DefaultModal.vue'
  import { createErrorFromResponse } from 'src/utils/error'

  export default {
    data () {
      return {
        modalOpened: false,
        backupCodes: [],
        authorizationPassword: null,
        loading: false
      }
    },

    methods: {
      open (authorizationPassword) {
        this.authorizationPassword = authorizationPassword

        new BackupCodesClient()
          .list(this.authorizationPassword)
          .then(response => {
            this.backupCodes = response.data.backup_codes
            this.modalOpened = true
          })
          .catch(createErrorFromResponse)
      },

      handleRegenerate () {
        this.loading = true

        new BackupCodesClient()
          .refresh(this.authorizationPassword)
          .then(response => {
            this.backupCodes = response.data.backup_codes
          })
          .catch(createErrorFromResponse)
          .then(() => {
            this.loading = false
          })
      },

      clearPassword () {
        this.authorizationPassword = null
      }
    },

    components: {
      AuthorizationDialog,
      BackupCodesArea,
      DefaultModal
    }
  }
</script>
